module.exports = __webpack_public_path__ + "img/198.cd94dc0f.jpg";